module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"calendarTitle":"Calendar for holidays not set for the next year","calendarNotSet":"Do you want to set it now?"},"et":{"calendarTitle":"Calendar for holidays not set for the next year","calendarNotSet":"Do you want to set it now?"},"ru":{"calendarTitle":"Calendar for holidays not set for the next year","calendarNotSet":"Do you want to set it now?"}}')
  delete Component.options._Ctor
}
